import { render, staticRenderFns } from "./button-share.vue?vue&type=template&id=56abc0aa"
import script from "./button-share.vue?vue&type=script&lang=js"
export * from "./button-share.vue?vue&type=script&lang=js"
import style0 from "./button-share.vue?vue&type=style&index=0&id=56abc0aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports